import React, { useEffect, useState } from "react";
import { TextField, Box, Typography, Grid, Button, Stack } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { GetAll } from "../../../util/request/getAll";
import BookingModal from "./bookModal";
import { convertTo12HourTimeCompact } from "../../../util/general/convertTo12HourTimeCompact";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import CancelIcon from "@mui/icons-material/Cancel";
import ChangeDateTime from "./chageDateTime";
const BookingCalendar = () => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [events, setEvents] = useState([]);
  const [refreshData, setRefreshData] = useState(false);
  const [fieldTrip, setFieldTrip] = useState([]);

  const excludedDaysAndTimes = {
    Mon: ["10:00", "12:00", "14:00", "16:00", "19:00", "20:00", "20:30"],
    Tue: ["10:00", "12:00", "14:00", "16:00", "19:00", "20:00", "20:30"], // Exclude these times on Tuesday
    Wed: ["10:00", "12:00", "14:00", "16:00", "19:00", "20:00", "20:30"],
    Thu: ["10:00", "12:00", "14:00", "16:00", "19:00", "20:00", "20:30"], // Exclude these times on Thursday
    Fri: ["10:00", "12:00", "14:00", "16:00", "19:00", "14:00"],
    Sat: ["12:00", "14:00", "15:30", "18:00", "20:00", "20:30"],
    Sun: ["12:00", "14:00", "15:30", "18:00", "20:00", "20:30"], // Exclude these times on Saturday
  };
  const isExcluded = (day, time) => {
    const excludedTimes = excludedDaysAndTimes[day]; // Get excluded times for the selected day
    return excludedTimes?.includes(time); // Check if the time is excluded
  };
  // Generate week days from selected date
  const getWeekDates = (startDate) => {
    const startOfWeek = startDate.startOf("week").add(1, "day"); // Start on Monday
    return Array.from({ length: 7 }, (_, i) => startOfWeek.add(i, "day"));
  };

  // console.log(new Date(selectedDate).setDate(selectedDate.getDate() + 7));
  const weekDates = getWeekDates(selectedDate);

  useEffect(() => {
    async function runFunc0() {
      const response = await GetAll({
        subLink: `booking?booking_status=booked
`,
      });
      if (response.data) {
        setEvents(response.data.data);
      }
    }

    runFunc0();
  }, [selectedDate, refreshData]);

  useEffect(() => {
    async function runFunc1() {
      const response = await GetAll({
        subLink: `fieldtrip?booking_status=booked
  `,
      });
      if (response.data) {
        setFieldTrip(response.data.data);
      }
    }

    runFunc1();
  }, [selectedDate, refreshData]);

  const handleNextWeekChange = () => {
    const newDate = selectedDate.add(7, "day"); // Add 7 days to the current value
    setSelectedDate(newDate);
  };
  const handlePrevWeekChange = () => {
    const newDate = selectedDate.add(-7, "day"); // Add 7 days to the current value
    setSelectedDate(newDate);
  };
  // Time slots (10 AM to 6 PM by 2-hour increments)
  // const timeSlots = Array.from({ length: 6 }, (_, i) => `${10 + i * 2}:00`);
  // console.log(timeSlots);
  const timeSlots = [
    "10:00",
    "12:00",
    "13:00",
    "14:00",
    "15:30",
    "16:00",
    "18:00",
    "19:00",
    "20:30",
  ];

  const formatDate = (isoString) => isoString.split("T")[0];

  const uniqueDays = fieldTrip.reduce((acc, item) => {
    const day = formatDate(item.date);
    if (!acc.includes(day)) {
      acc.push(day);
    }
    return acc;
  }, []);

  console.log(uniqueDays);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {/* {openBookingModal && (
        <BookingModal open={openBookingModal}></BookingModal>
      )} */}
      <Box p={2} sx={{ width: "730px" }}>
        {/* Date Picker */}
        <Stack direction="row" justifyContent="space-between">
          <DatePicker
            slotProps={{
              actionBar: { actions: [] }, // Remove Cancel and OK buttons
            }}
            closeOnSelect // Automatically closes after a date is sele
            label="Select Week"
            value={selectedDate}
            onChange={(newValue) => setSelectedDate(newValue)}
            renderInput={(params) => <TextField {...params} />}
          />
          <Stack direction="row">
            <Button
              variant="contained"
              startIcon={<NavigateBeforeIcon />}
              sx={{
                marginTop: "20px",
                marginBottom: "20px",
                marginRight: "20px",
                maxWidth: "80px",
              }}
              onClick={handlePrevWeekChange}
            >
              Prev
            </Button>
            <Button
              variant="contained"
              endIcon={<NavigateNextIcon />}
              sx={{
                marginTop: "20px",
                marginBottom: "20px",

                maxWidth: "80px",
              }}
              onClick={handleNextWeekChange}
            >
              Next
            </Button>
          </Stack>
        </Stack>
        {/* Week Header */}
        <Box ml={9}>
          <Grid container spacing={1} alignItems="center">
            {weekDates.map((date) => (
              <Grid item xs key={date}>
                <Box
                  sx={{
                    textAlign: "center",
                    margin: 0,
                    padding: 0,
                    height: "20px",
                  }}
                >
                  {uniqueDays.includes(date.format("YYYY-MM-DD")) ? (
                    <Box
                      sx={{
                        margin: 0,
                        padding: 0,
                        color: "white",
                        backgroundColor: "green",
                        borderRadius: "10px",
                      }}
                    >
                      {" "}
                      {date.format("ddd")}(FT)
                    </Box>
                  ) : (
                    <Box sx={{ margin: 0, padding: 0 }}>
                      {date.format("ddd")}
                    </Box>
                  )}{" "}
                  <br />
                </Box>
                <Typography align="center" sx={{ margin: 0, padding: 0 }}>
                  {date.format("MM/DD")}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Time Slots */}
        <Box
          mt={3}
          sx={{ maxHeight: "calc(100vh - 400px)", overflowY: "AUTO" }}
        >
          <Grid container spacing={1} alignItems="flex-start">
            <Grid item xs={1}>
              {/* Time Column */}
              {timeSlots.map((time) => (
                <Box
                  sx={{ minWidth: "50px" }}
                  key={time}
                  p={1}
                  textAlign="center"
                  minHeight="135px"
                  borderBottom="1px solid #ccc"
                >
                  {convertTo12HourTimeCompact(time)}
                </Box>
              ))}
            </Grid>
            {weekDates.map((date) => (
              <Grid item xs key={date}>
                {/* Day Column */}
                {timeSlots.map((time) => {
                  // Filter events for the specific date and time slot
                  const filteredEvents = events.filter(
                    (event) =>
                      event.bookingDetail.party_date.slice(0, 10) ===
                        date.format("YYYY-MM-DD") &&
                      event.bookingDetail.party_time === time
                  );

                  return (
                    <Box
                      key={time}
                      // p={1}

                      textAlign="center"
                      border="1px solid #ccc"
                      sx={{
                        width: "80px",
                        maxWidth: "80px",
                        height: "150px",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#f0f0f0" },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        minHeight: `140px`, // Adjust height based on events
                        transition: "min-height 0.3s ease",
                        backgroundColor: isExcluded(date.format("ddd"), time)
                          ? "#e5e1e1c5"
                          : "white",
                      }}
                      // onClick={() => handleSlotClick(date, time)}
                    >
                      <Stack sx={{ width: "100%" }}>
                        <Box
                          sx={{
                            textAlign: "right",
                            maxHeight: "30px",
                          }}
                        >
                          {!isExcluded(date.format("ddd"), time) && (
                            <BookingModal
                              party_date={date.format("YYYY-MM-DD")}
                              party_time={time}
                              reFreshData={() =>
                                setRefreshData((prev) => !prev)
                              }
                            ></BookingModal>
                          )}
                        </Box>
                        {isExcluded(date.format("ddd"), time) && (
                          <Stack
                            direction="column"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ flexGrow: 1 }}
                          >
                            <CancelIcon
                              fontSize="large"
                              sx={{ color: "gray" }}
                            />
                            <Box sx={{ fontSize: "12px" }}>Not Available</Box>
                          </Stack>
                        )}
                        {filteredEvents.map((event, index) => (
                          <Stack justifyContent="center">
                            <Typography
                              key={index}
                              variant="body2"
                              sx={{
                                marginTop: "4px",
                                fontSize: "14px",
                                width: "fit-content",
                                textAlign: "left",
                                padding: "0px",
                                borderRadius: "5px",
                                border:
                                  event.booking_status == "pending"
                                    ? "2px dashed gray"
                                    : "",
                                color:
                                  event.booking_status == "pending"
                                    ? "black"
                                    : "white",
                                bgcolor:
                                  event.booking_status == "pending"
                                    ? "white"
                                    : event.package.package_name ===
                                        "Giant Room" ||
                                      event.package.package_name ===
                                        "Giant Party"
                                    ? "blue"
                                    : event.package.package_name ===
                                        "Large Room" ||
                                      event.package.package_name ===
                                        "Large Party"
                                    ? "orange"
                                    : event.package.package_name ===
                                        "Medium Room" ||
                                      event.package.package_name ===
                                        "Medium Party"
                                    ? "green"
                                    : "purple",

                                zIndex: 2,
                              }}
                            >
                              {/* {event.package.package_name.slice(0, 1)}
                              {[
                                "Small Party",
                                "Medium Party",
                                "Large Party",
                                "Giant Party",
                              ].includes(event.package.package_name)
                                ? "*"
                                : null}
                              {"-"}
                              {event.bookingDetail.celebrant.slice(0, 7)} */}
                              <ChangeDateTime
                                eventData={event}
                                reFreshData={() =>
                                  setRefreshData((prev) => !prev)
                                }
                              />
                            </Typography>
                          </Stack>
                        ))}
                      </Stack>
                    </Box>
                  );
                })}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default BookingCalendar;
